// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_participantNames_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "Agent",
    "AnonymousConversationParticipant"
  ]);
}

let fragmentConverter = {"__root":{"participantNames_edges_node":{"u":"fragment_participantNames_edges_node"},"lastMessage":{"f":""},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_participantNames_edges_node: unwrap_fragment_participantNames_edges_node
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationsListItem_conversation",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "ConversationMessageV5",
        "kind": "LinkedField",
        "name": "lastMessage",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationsListItem_lastMessage"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": "unreadMessages",
      "args": [
        {
          "kind": "Literal",
          "name": "readState",
          "value": "UNREAD"
        }
      ],
      "concreteType": "ConversationMessagesConnection",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "messages(readState:\"UNREAD\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationsListItemParticipants_conversation"
    },
    {
      "alias": "participantNames",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "ConversationParticipantConnection",
      "kind": "LinkedField",
      "name": "participants",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ConversationParticipantEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        }
                      ],
                      "type": "Agent",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "type": "AnonymousConversationParticipant",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": "participants(first:20)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationsListItemContext_conversation"
    }
  ],
  "type": "ConversationV5",
  "abstractKey": null
};
})());

let wrap_fragment_participantNames_edges_node = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_participantNames_edges_node = unwrap_fragment_participantNames_edges_node;
exports.wrap_fragment_participantNames_edges_node = wrap_fragment_participantNames_edges_node;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
